import React, { useEffect, useState } from 'react';
import { Box, Text, Flex, Center, Spinner, Tooltip } from '@chakra-ui/react';
import MyDiv from './holidayCard.style';
import { useFetch } from '../../../../hooks/useFetch';
import { CustomToast } from '../../../../components';
import { Holiday } from './model';
import { showDate } from '../../../../utilities/helper';

const HolidayCard = () => {
  const [holidays, setHolidays] = useState<Holiday[]>([]);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  const loadHolidays = async () => {
    const response = await fetchApi<Holiday[]>('Dashboard/Holidays', 'GET');

    if (Array.isArray(response)) {
      setHolidays(response);
    } else {
      setHolidays([]);
    }
  };

  useEffect(() => {
    loadHolidays();
  }, []);

const formatDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-').map(Number);
  const date = new Date(year, month - 1, day);
  return {
    day: String(date.getDate()).padStart(2, '0'),
    month: date.toLocaleString('default', { month: 'short' }).toUpperCase(),
    formatted: `${String(date.getDate()).padStart(2, '0')}/${String(  date.getMonth() + 1
    ).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`
  };
};

  return (
    <MyDiv>
      <Box className='common_bg' p={2} rounded="xl" boxShadow="sm">
        <Text className='font-poppins text_medium text_lg' mb={2}>Upcoming Holidays</Text>
        <Box className="holiday-list">
          <Box position="relative" minH="300px">
            {loading ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Spinner
                  thickness="4px"
                  speed="0.65s"
                  emptyColor="gray.200"
                  color="#006838"
                  size="xl"
                />
              </Center>
            ) : holidays.length === 0 ? (
              <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                <Text className="font-poppins text_medium text_lg" color="gray.500">
                  No Holiday Available.
                </Text>
              </Center>
            ) : (
              <>
                {holidays.map((holiday, index) => {
                  const { day, month, formatted } = formatDate(holiday.date);
                  return (
                    <Box pl={4} pr={4} className="holiday-row" key={index}>
                      <Flex align="center" justify="space-between">
                        <Box className="date-box">
                          <Text className="month font-poppins text_medium">{month}</Text>
                          <Text className="day font-poppins text_bold text_sm">{day}</Text>
                        </Box>
                        <Box flex="1" ml={4}>
                          <Flex justify={"space-between"}>
                            <Text className="holiday-date font-poppins text_medium">{showDate(holiday.date)}</Text>
                            <Tooltip label={holiday.department} aria-label="Full reason" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow>
                              <Text className="holiday-date font-poppins text_medium" maxWidth="9vw" isTruncated>{holiday.department}</Text>
                            </Tooltip>
                          </Flex>
                          <Text className="text_medium text_lg font-poppins">{holiday.title}</Text>
                          <Tooltip label={holiday.businessProcess} aria-label="Full reason" bg="gray.700" color="white" placement="bottom-start" maxW="300px" hasArrow>


                            <Text className="holiday-date font-poppins text_medium" maxWidth="9vw" isTruncated>{holiday.businessProcess}</Text>
                          </Tooltip>
                        </Box>
                      </Flex>
                    </Box>
                  );
                })}
              </>
            )}
          </Box>
        </Box>
      </Box>
    </MyDiv>
  );
};

export default HolidayCard;
